import React from 'react';
import ReactCurvedText from '../CurvedText/ReactCurvedText';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import css from './RotatingButton.module.css';
import classNames from 'classnames';

const RotatingButton = props => {
  const {
    label,
    successMessage,
    loadingMessage,
    inProgress,
    disabled,
    ready,
    type,
    className,
  } = props;

  const customStyles = props.customStyles || {};
  let buttonText = label;

  if (ready) {
    buttonText = successMessage || 'SUCCESS';
  }
  if (inProgress) {
    buttonText = loadingMessage || 'LOADING';
  }
  if (!ready && !inProgress) {
    buttonText = label;
  }

  return (
    <button type={type || 'submit'} className={classNames(css.wrapper, className)}>
      <div className={css.joinRotationCTAContainer}>
        <div className={css.rotateDiv}>
          <ReactCurvedText
            width="250"
            height="250"
            cx="125"
            cy="125"
            rx={70}
            ry={70}
            startOffset="0"
            reversed={true}
            text={`${buttonText}`} //"JOIN THE ROTATION · JOIN THE ROTATION ·"
            textProps={{ style: { fontWeight: '400', fontSize: '25', textTransform: 'uppercase', ...customStyles } }}
            textPathProps={null}
            tspanProps={{ dy: '0' }}
            ellipseProps={null}
            svgProps={{ style: { transform: 'rotate(-28deg)' } }}
            disabled={disabled}
          />
        </div>
        <div className={css.joinArrow}>
          <ArrowForwardIosIcon style={{ fontSize: '40px', fontWeight: 'bold' }} />
        </div>
      </div>
    </button>
  );
};

export default RotatingButton;
